import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=2f9ae8b6"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9ae8b6')) {
      api.createRecord('2f9ae8b6', component.options)
    } else {
      api.reload('2f9ae8b6', component.options)
    }
    module.hot.accept("./CustomerList.vue?vue&type=template&id=2f9ae8b6", function () {
      api.rerender('2f9ae8b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Application/Customers/CustomerList.vue"
export default component.exports